import * as React from 'react';
import { createNamedContext } from "../../helpers/context";
export var DrawerContext = createNamedContext('DrawerContext', null);